import { InfoOutlined } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'

interface DrawerDescriptionProps {
  description: string
}

export function DrawerDescription({ description }: Readonly<DrawerDescriptionProps>) {
  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <InfoOutlined />
        <Typography gutterBottom color="text.primary" variant="body1" whiteSpace="pre-wrap">
          {description}
        </Typography>
      </Stack>
    </Box>
  )
}
